import React from "react";
import moment from "moment";
import styles from "./MainForm.module.css";
import { frontDB } from "../../../../../frontDB";
import {
  Form,
  InputPicker,
  Input,
  DatePicker,
  Divider,
  Popover,
  Whisper,
} from "rsuite";
import {
  isInputOptional,
  isItemsReadonly,
  filterUsers,
  getAccessLevel,
  getUserId,
  getResponsibleName,
} from "../../../../../helperFunctions";
import ItemsBlock from "../../Components/ItemsBlock/ItemsBlock";
import AccountCodeBlock from "../../Components/AccountCodeBlock/AccountCodeBlock";
import OtherChargesBlock from "../../Components/OtherChargesBlock/OtherChargesBlock";
import {
  invoiceStatus,
  invoiceDepartments,
  invoiceTypeOptions,
  invoiceBankNamesOptions,
  invoiceVesselsOptions,
  documentTypeOptions,
} from "../../../../Settings/Data/lists";
import { useInvoices } from "../../useInvoices";
import PdfIconFile from "../../../../../Components/Icons/pdf.png";
import POIconFile from "../../../../../Components/Icons/po.png";
import PdfPreviewFrame from "../../Components/PdfPreview/PdfPreviewFrame";
import PdfPreview from "../../Components/PdfPreview/PdfPreview";

function MainForm({
  formMode,
  readonly,
  invoiceModel,
  form,
  formHandler,
  topButton,
}) {
  let {
    userHandler,
    departmentHandler,
    invoiceTypeHandler,
    invoiceStatusHandler,
    accountHandler,
    vesselHandler,
    documentTypeHandler,
    invoiceDateHandler,
    invoiceDueDateHandler,
    invoiceBankHandler,
    handlepdfFrameShow,
    handlepdfFrameClose,
    ispdfFrameShow,
    pdfPositionY,
    updateStatus,
  } = useInvoices();
  const inputType = isInputOptional(form.type);
  const itemsReadonly = getAccessLevel() >= 1 ? false : true;
  const userId = getUserId();
  const showSysLogs = userId === "6540f759e2670050576026123" ? true : false;

  if (form?.document_type == undefined) form.document_type = "Invoice";

  let { accounts, users, locations } = frontDB();
  let filter = {
    location: "659a601d38d14accc6a6b0ec",
    status: "Active",
    responsible: "All responsibles",
  };
  let officeUsers = filterUsers(filter, users);

  let officeUsersOptions = officeUsers.map((item) => ({
    label: `${item.name} ${item.responsible}`,
    value: item._id,
  }));

  officeUsersOptions = [
    ...officeUsersOptions,
    { label: "Unassigned", value: "Unassigned" },
  ];

  let accountNumberOptions = accounts.map((item) => ({
    category: item.category,
    label: `${item.number} ${item.description}`,
    value: item._id,
  }));

  // let vesselNameOptions = locations
  //   .filter(
  //     (location) => location.status == "active" && location.name != "Office"
  //   )
  //   .map((item) => ({
  //     label: `${item.name}`,
  //     value: item.name,
  //   }));
  // console.log(vesselNameOptions)
  // vesselNameOptions = [{ label: "NA", value: "NA" }, ...vesselNameOptions];
  const vesselNameOptions = [
    { label: "NA", value: "NA" },
    ...invoiceVesselsOptions,
  ];

  if (form?.user_id == undefined) form.user_id = "Unassigned";
  const responsibleName = getResponsibleName();
  const isAdmin = ["Admin"].includes(responsibleName) ? true : false;
  const isPaymentStatusAvailable = ["Admin", "Accounter"].includes(
    responsibleName,
  )
    ? true
    : false;

  const isBankSelectionAvailable = ["Approved", "For payment", "Paid"].includes(
    form?.invoice_status,
  )
    ? true
    : false;

  // const isBankSelectionDisabled =
  //   ["For payment", "Paid"].includes(form?.invoice_status) &&
  //   !isPaymentStatusAvailable
  //     ? true
  //     : false;
  const isBankSelectionEnabled =
    ["Approved"].includes(form?.invoice_status) &&
    ["Admin", "Accounter"].includes(responsibleName)
      ? true
      : false;
  // const statusOptions = isPaymentStatusAvailable
  //   ? [
  //       ...invoiceStatus,
  //       { label: "For payment", value: "For payment" },
  //       { label: "Paid", value: "Paid" },
  //     ]
  //   : invoiceStatus;
  const tooltip = <Popover>Click to show or close PDF</Popover>;
  const PdfIcon = (
    <div
      onClick={(e) => handlepdfFrameShow(e)}
      style={{
        width: 25,
        height: 30,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        transition: "0.5s",
        backgroundColor: "transparent",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.3)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <Whisper
        delay={500}
        placement="bottomStart"
        controlId="control-id-hover"
        trigger="hover"
        speaker={tooltip}
      >
        <img
          src={PdfIconFile}
          alt="View PDF"
          style={{ width: "100%", height: "100%" }}
        />
      </Whisper>
    </div>
  );

  return (
    <>
      <Form
        readOnly={readonly}
        model={invoiceModel}
        onChange={formHandler}
        formValue={form}
      >
        <div className={styles.inputs_container}>
          <Form.Group controlId="department">
            <Form.ControlLabel>Department</Form.ControlLabel>
            <InputPicker
              readOnly={readonly}
              cleanable={false}
              name="department"
              onChange={departmentHandler}
              value={form?.department}
              placeholder="Select department"
              data={invoiceDepartments}
              style={{ width: "250px" }}
            />
          </Form.Group>

          <Form.Group controlId="user_id">
            <Form.ControlLabel>Assign User</Form.ControlLabel>
            <InputPicker
              readOnly={readonly}
              cleanable={false}
              name="user_id"
              onChange={userHandler}
              value={form?.user_id}
              placeholder="Select user"
              data={officeUsersOptions}
              style={{ width: "250px" }}
            />
          </Form.Group>

          <Form.Group controlId="type">
            <Form.ControlLabel>{form.document_type} type</Form.ControlLabel>
            <InputPicker
              readOnly={readonly}
              cleanable={false}
              name="type"
              value={form?.type}
              onChange={invoiceTypeHandler}
              data={invoiceTypeOptions}
              placeholder="Select"
              style={{ width: "250px" }}
            />
          </Form.Group>

          <Form.Group controlId="vessel_name">
            <Form.ControlLabel>Vessel Name</Form.ControlLabel>
            <InputPicker
              readOnly={readonly}
              cleanable={false}
              name="vessel_name"
              onChange={vesselHandler}
              value={form?.vessel_name}
              placeholder="Select vessel"
              data={vesselNameOptions}
              style={{ width: "250px" }}
              menuStyle={{ width: "250px" }}
            />
          </Form.Group>

          <Form.Group controlId="vessel_name">
            <Form.Group controlId="purchase_order_number">
              <Form.ControlLabel>Purchase order</Form.ControlLabel>
              <Form.Control
                style={{ width: "250px" }}
                name="purchase_order_number"
              />{" "}
              <span style={{ width: 40 }}>
                {form?.purchase_order_id &&
                  POFoundIcon(form?.purchase_order_file)}
              </span>
            </Form.Group>
          </Form.Group>
          {/* {!isBankSelectionAvailable && (
						<>
							<Form.Group></Form.Group>
							<Form.Group></Form.Group>
						</>
					)} */}

          {isBankSelectionAvailable && (
            <>
              <Form.Group controlId="type">
                <Form.ControlLabel>Bank for payment</Form.ControlLabel>
                <InputPicker
                  readOnly={!isBankSelectionEnabled}
                  cleanable={false}
                  name="type"
                  value={form?.invoice_bank}
                  onChange={invoiceBankHandler}
                  data={invoiceBankNamesOptions}
                  placeholder="Select"
                  style={{ width: "250px" }}
                />
              </Form.Group>
            </>
          )}
        </div>
        <div style={{ width: "960px" }}>
          <div style={{ padding: "0 0 40px 40px" }}>{topButton}</div>
          <Divider>
            <Form.Group controlId="document_type">
              <InputPicker
                readOnly={readonly}
                cleanable={false}
                name="document_type"
                onChange={documentTypeHandler}
                value={form?.document_type}
                placeholder="Select document type"
                data={documentTypeOptions}
                style={{ width: "250px" }}
                menuStyle={{ width: "250px" }}
              />
            </Form.Group>
          </Divider>
        </div>

        <div style={{ width: "880px" }}></div>

        <div className={styles.invoice_container}>
          <span style={{ marginTop: 10, paddingRight: 10, float: "right" }}>
            {PdfIcon}
          </span>
          {ispdfFrameShow && (
            <PdfPreviewFrame selectedPdf={form?.invoice_filename} />
          )}
          <div className={styles.invoice_header_container}>
            <Form.Group controlId="invoice_number">
              <Form.ControlLabel>{form.document_type} Number</Form.ControlLabel>
              <Form.Control style={{ width: "250px" }} name="invoice_number" />
            </Form.Group>

            <Form.Group controlId="invoice_date">
              <Form.ControlLabel style={{ width: "250px" }}>
                {form.document_type} Date
              </Form.ControlLabel>
              <DatePicker
                readOnly={readonly}
                oneTap
                value={new Date(form?.invoice_date)}
                onChange={(value) => invoiceDateHandler(value)}
                isoWeek
                cleanable={false}
                format="dd/MM/yyyy"
                appearance="default"
                placeholder="Invoice date"
                style={{ width: 250 }}
              />
            </Form.Group>

            <Form.Group controlId="invoice_due_date">
              <Form.ControlLabel style={{ width: "250px" }}>
                {form.document_type} Due Date
              </Form.ControlLabel>
              <DatePicker
                readOnly={readonly}
                oneTap
                value={
                  form?.invoice_due_date
                    ? new Date(form?.invoice_due_date)
                    : undefined
                }
                onChange={(value) => invoiceDueDateHandler(value)}
                isoWeek
                cleanable={false}
                format="dd/MM/yyyy"
                appearance="default"
                placeholder="Date"
                style={{
                  width: 250,
                  border: form?.invoice_due_date ? "0px" : "1px solid red",
                }}
              />
            </Form.Group>

            <Form.Group controlId="invoice_from">
              <Form.ControlLabel className={styles.bold_text}>
                From
              </Form.ControlLabel>
              <Form.Control
                style={{ width: "250px" }}
                rows={4}
                name="invoice_from"
                accepter={Textarea}
              />
            </Form.Group>

            <Form.Group controlId="invoice_to">
              <Form.ControlLabel className={styles.bold_text}>
                To
              </Form.ControlLabel>
              <Form.Control
                style={{ width: "250px" }}
                rows={4}
                name="invoice_to"
                accepter={Textarea}
              />
            </Form.Group>
            <Form.Group controlId="invoice_from">
              <div></div>
            </Form.Group>
          </div>
          <ItemsBlock
            readonly={readonly}
            formMode={formMode}
            itemsTitles={form.invoice_items_title}
            invoiceItems={form.invoice_items}
            invoiceId={form?.invoice_number}
          />
          <div className={styles.bottom_container}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
              }}
            >
              {/* Notes Section */}
              <div style={{ flex: 1, paddingRight: "20px" }}>
                <Form.Group controlId="notes">
                  <Form.ControlLabel>Notes</Form.ControlLabel>
                  <Form.Control
                    rows={6}
                    style={{ width: "400px" }}
                    accepter={Textarea}
                    name="notes"
                  />
                </Form.Group>

                {/* OCR QC result — Admin only. Set server-side by verifyOCR
                    after the invoice is created; cannot be edited from the form. */}
                {isAdmin && form?.qcResult && (
                  <div style={{ marginTop: 16, width: 400 }}>
                    <Form.ControlLabel>OCR QC</Form.ControlLabel>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 10,
                        padding: 10,
                        border: "1px solid #e5e7eb",
                        borderRadius: 6,
                        background:
                          form.qcResult === "pass" ? "#f0fdf4" : "#fef2f2",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          padding: "2px 10px",
                          borderRadius: 10,
                          fontSize: 11,
                          fontWeight: 600,
                          color: "#fff",
                          background:
                            form.qcResult === "pass" ? "#16a34a" : "#dc2626",
                          flexShrink: 0,
                          marginTop: 2,
                        }}
                      >
                        {form.qcResult}
                      </span>
                      <div
                        style={{
                          color: "#374151",
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                          lineHeight: 1.4,
                        }}
                      >
                        {/* Backend joins issues with '; ' — split so each one
                            renders on its own line for readability, with a
                            blank line between issues.

                            Note: fontSize is applied to EACH inner <div>, not
                            the wrapper. rsuite's .rs-form CSS sets a baseline
                            font-size on nested block elements that overrides
                            a wrapper-only style — putting it per-line keeps
                            the size where we want it. */}
                        {form.qcMessage
                          ? form.qcMessage
                              .split(";")
                              .map(/** @param {string} s */ (s) => s.trim())
                              .filter(Boolean)
                              .map(
                                /** @param {string} issue @param {number} i */
                                (issue, i) => (
                                  <div
                                    key={i}
                                    style={{
                                      fontSize: 11,
                                      lineHeight: 1.4,
                                      marginBottom: 10,
                                    }}
                                  >
                                    {i + 1}. {issue}
                                  </div>
                                ),
                              )
                          : <span style={{ fontSize: 11 }}>—</span>}
                        {form.qcModel && (
                          <div
                            style={{
                              fontSize: 10,
                              color: "#9ca3af",
                              marginTop: 4,
                            }}
                          >
                            {form.qcCheckedAt
                              ? ` · ${moment
                                  .utc(form.qcCheckedAt, moment.ISO_8601)
                                  .format("DD/MM/YYYY HH:mm")}`
                              : ""}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Invoice Details Section */}
              <div>
                <div
                  className={styles.invoice_summary}
                  // style={{
                  //   width: "420px",
                  //   display: "flex",
                  //   flexDirection: "column",
                  //   alignItems: "flex-end",
                  //   gap: "10px",
                  //   padding: "25px 40px 0 30px",
                  //   backgroundColor: "#fbfbfb",
                  // }}
                >
                  <div key="invoice_subtotal" className={styles.other_charges}>
                    <Form.ControlLabel>Subtotal</Form.ControlLabel>
                    <Form.Group
                      controlId="invoice_currency"
                      style={{ marginBottom: 0 }}
                    >
                      <Form.Control
                        readOnly
                        style={{ width: "60px" }}
                        name="invoice_currency"
                      />
                    </Form.Group>

                    <Form.Group
                      controlId="invoice_subtotal"
                      style={{ marginBottom: 0 }}
                    >
                      <Form.Control
                        style={{ width: "150px" }}
                        name="invoice_subtotal"
                      />
                    </Form.Group>
                  </div>

                  <div key="invoice_discount" className={styles.other_charges}>
                    <Form.ControlLabel>Discount</Form.ControlLabel>
                    <Form.Group
                      controlId="invoice_currency"
                      style={{ marginBottom: 0 }}
                    >
                      <Form.Control
                        readOnly
                        style={{ width: "60px" }}
                        name="invoice_currency"
                      />
                    </Form.Group>

                    <Form.Group
                      controlId="invoice_discount"
                      style={{ marginBottom: 0 }}
                    >
                      <Form.Control
                        style={{ width: "150px" }}
                        name="invoice_discount"
                      />
                    </Form.Group>
                  </div>
                  <div key="invoice_tax" className={styles.other_charges}>
                    <Form.ControlLabel>Taxes</Form.ControlLabel>
                    <Form.Group
                      controlId="invoice_currency"
                      style={{ marginBottom: 0 }}
                    >
                      <Form.Control
                        readOnly
                        style={{ width: "60px" }}
                        name="invoice_currency"
                      />
                    </Form.Group>

                    <Form.Group
                      controlId="invoice_tax"
                      style={{ marginBottom: 0 }}
                    >
                      <Form.Control
                        style={{ width: "150px" }}
                        name="invoice_tax"
                      />
                    </Form.Group>
                  </div>
                </div>
                <OtherChargesBlock
                  readonly={readonly}
                  formMode={formMode}
                  currency={form.invoice_currency}
                  otherChargesArr={form?.invoice_other_charges}
                  invoiceOtherOld={form?.invoice_other_cost}
                />
                <div className={styles.invoice_summary}>
                  <div
                    key="invoice_vat"
                    className={styles.other_charges}
                    style={{ marginBottom: "15px" }}
                  >
                    <Form.ControlLabel>VAT</Form.ControlLabel>
                    <Form.Group
                      controlId="invoice_currency"
                      style={{ marginBottom: 0 }}
                    >
                      <Form.Control
                        readOnly
                        style={{ width: "60px" }}
                        name="invoice_currency"
                      />
                    </Form.Group>

                    <Form.Group
                      controlId="invoice_vat"
                      style={{ marginBottom: 0 }}
                    >
                      <Form.Control
                        style={{ width: "150px" }}
                        name="invoice_vat"
                      />
                    </Form.Group>
                  </div>
                </div>
                <div>
                  <div key="invoice_total" className={styles.invoice_total}>
                    <div
                      key="invoice_total"
                      className={styles.invoice_total_item}
                    >
                      <Form.ControlLabel className={styles.bold_text}>
                        {form.document_type} Total
                      </Form.ControlLabel>
                      <Form.Group
                        controlId="invoice_currency"
                        style={{ marginBottom: 0 }}
                      >
                        <Form.Control
                          style={{ width: "60px" }}
                          name="invoice_currency"
                        />
                      </Form.Group>

                      <Form.Group
                        controlId="invoice_total"
                        style={{ marginBottom: 0 }}
                      >
                        <Form.Control
                          style={{ width: "150px" }}
                          name="invoice_total"
                        />
                      </Form.Group>
                    </div>
                  </div>

                  <AccountCodeBlock
                    readonly={readonly}
                    formMode={formMode}
                    invoiceCodes={form.invoice_codes}
                    accountNumberOptions={accountNumberOptions}
                    total_by_accounts={form?.total_by_accounts}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {showSysLogs && (
          <div className={styles.bottom_container}>
            <Form.Group controlId="email_logs">
              <Form.ControlLabel>Email processing logs</Form.ControlLabel>
              <Form.Control
                style={{ width: "880px" }}
                rows={6}
                name="email_logs"
                accepter={Textarea}
              />
            </Form.Group>

            <Form.Group controlId="ocr_logs">
              <Form.ControlLabel>
                {form.document_type} processing logs
              </Form.ControlLabel>
              <Form.Control
                style={{ width: "880px" }}
                rows={6}
                name="ocr_logs"
                accepter={Textarea}
              />
            </Form.Group>
          </div>
        )}

        {isAdmin && (
          <div style={{ paddingTop: 20 }}>
            <Form.Group controlId="invoice_status">
              <Form.ControlLabel>
                {" "}
                Change Status{" "}
                <span style={{ fontSize: 10 }}>
                  (This field is visible only for Admin)
                </span>
              </Form.ControlLabel>
              <InputPicker
                readOnly={!isAdmin}
                cleanable={false}
                name="invoice_status"
                onChange={updateStatus}
                value={form?.invoice_status}
                placeholder="Select status"
                data={invoiceStatus}
                style={{ width: "250px" }}
                menuStyle={{ width: "250px" }}
              />
            </Form.Group>
          </div>
        )}
      </Form>
    </>
  );
}

export default MainForm;

const Textarea = React.forwardRef((props, ref) => (
  <Input {...props} as="textarea" ref={ref} />
));

const POFoundIcon = (poURL) => {
  if (poURL === undefined) poURL = "";
  const tooltip = (
    <Popover>
      Click to download the Purchase Order PDF for the matched PO. If the file
      is incorrect, please enter the correct PO number to fetch the right file.
    </Popover>
  );
  const handleDownloadPdf = (e, pdfUrl) => {
    e.stopPropagation();

    if (pdfUrl) {
      // window.open(pdfUrl, '_blank');
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  return (
    <span>
      <Whisper
        delay={300}
        placement="bottomStart"
        controlId="control-id-hover"
        trigger="hover"
        speaker={tooltip}
      >
        <img
          onClick={(e) => handleDownloadPdf(e, poURL)}
          style={{
            cursor: "pointer",
            width: 40,
            marginTop: 2,
            transition: "0.5s",
            backgroundColor: "transparent",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.3)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          src={POIconFile}
          alt="Purchase order"
        />
      </Whisper>
    </span>
  );
};
